'use client'

import { useState } from 'react'
import { CalendarCheck, ShoppingBag } from 'lucide-react'
import { AnimatedBookingFlow } from './animated-booking-flow'
import { AnimatedOrdersFlow } from './animated-orders-flow'
import { Tilt3D } from './tilt-3d'

// The hero preview used to show only the reservation demo, which undersold
// the product (and audits flagged the missing ordering entry point). This
// lets the visitor flip between the two flows right in the hero.
const LABELS: Record<string, { booking: string; orders: string }> = {
  de: { booking: 'Reservierung', orders: 'Bestellung & Speisekarte' },
  en: { booking: 'Reservation', orders: 'Ordering & menu' },
  tr: { booking: 'Rezervasyon', orders: 'Sipariş & menü' },
}

export function HeroDemoSwitch({ lang }: { lang: string }) {
  const [tab, setTab] = useState<'booking' | 'orders'>('booking')
  const t = LABELS[lang] ?? LABELS.de

  const pill = (active: boolean) =>
    `inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-[12px] font-semibold transition-all ${
      active
        ? 'bg-brand-600 text-white shadow-sm'
        : 'text-pub-muted hover:text-pub-ink'
    }`

  return (
    <div>
      <div className="mb-4 flex justify-center">
        <div className="inline-flex items-center gap-1 rounded-full border border-pub-rule bg-pub-surface p-1">
          <button type="button" className={pill(tab === 'booking')} onClick={() => setTab('booking')}>
            <CalendarCheck className="h-3.5 w-3.5" />
            {t.booking}
          </button>
          <button type="button" className={pill(tab === 'orders')} onClick={() => setTab('orders')}>
            <ShoppingBag className="h-3.5 w-3.5" />
            {t.orders}
          </button>
        </div>
      </div>
      <Tilt3D max={6}>
        {tab === 'booking' ? <AnimatedBookingFlow /> : <AnimatedOrdersFlow />}
      </Tilt3D>
    </div>
  )
}
